import { Button } from 'components/buttons/Button/Button';
import uniferIcon from 'images/icons/uniferIcon.svg';
import './styles.scss';

const YoutubeLink = ({ image, videoId, title, icon = uniferIcon }) => {
    const onOpenLink = () => {
        window.open(videoId, '_blank');
    };

    return (
        <div className="youtube-link">
            <div className="youtube-link__title">
                <img src={icon} alt="uniferX icon" />
                <p className="description-demibold">{title}</p>
            </div>
            <Button type="youtube" className="youtube-link_button" onClick={onOpenLink} />
            <img src={image} alt="Video Thumbnail" className="youtube-link__image" />
        </div>
    );
};

export default YoutubeLink;
